import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { AuthShell, GoogleButton, Field, inputClass } from "@/pages/auth/authShared";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate(from, { replace: true });
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Log in to see your classes and dances"
      footer={<>New here? <Link to="/register" state={{ from }} className="font-semibold text-[#B04B26] hover:underline">Create an account</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email"><input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} data-testid="login-email" autoComplete="email" /></Field>
        <Field label="Password"><input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} data-testid="login-password" autoComplete="current-password" /></Field>
        {error && <p className="rounded-lg bg-[#FEF2F2] px-3 py-2 text-sm font-semibold text-[#991B1B]" data-testid="login-error">{error}</p>}
        <div className="text-right"><Link to="/forgot-password" className="text-sm font-semibold text-[#B04B26] hover:underline">Forgot password?</Link></div>
        <button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-xl bg-[#C85A32] px-4 py-3 font-bold text-white hover:bg-[#B04B26] disabled:opacity-60">{loading ? "Logging in…" : "Log in"}</button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-[#6E5B51]"><span className="h-px flex-1 bg-border" /> or <span className="h-px flex-1 bg-border" /></div>
      <GoogleButton next={from} />
    </AuthShell>
  );
}
